module.exports = __webpack_public_path__ + "media/images/logo-fad3ea31277bb73f4544e70d58cf5536.png";